"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RangeSlider", {
    enumerable: true,
    get: function() {
        return RangeSliderNamespace;
    }
});
var _react = require("@chakra-ui/react");
var RangeSliderNamespace = Object.assign(_react.RangeSlider, {
    Track: _react.RangeSliderTrack,
    FilledTrack: _react.RangeSliderFilledTrack,
    Thumb: _react.RangeSliderThumb
});
